<script setup lang="ts">
import { onMounted, ref } from "vue";
import { MainDashboard } from "~/api";
import { useMyInfoStore } from "~/stores/MyInfoStore";
import { apiClient } from "~/utils/apiClient";

const myInfoStore = useMyInfoStore();

const loading = ref(false);
const complianceItemStatistics = ref<MainDashboard>();

/**
 * Fetches statistics for the dashboard
 */

const getDashboardStatistics = async () => {
  loading.value = true;
  const temp = await apiClient.mainDashboard.getComplianceItemStatistics(
    myInfoStore.currentSysOrgGuid,
  );
  complianceItemStatistics.value = temp;
};

onMounted(async () => {
  await Promise.all([getDashboardStatistics()]);
});
</script>
<template>
  <div class="main-dashboard">
    <div class="dashboard-section">
      <h4>Compliance Checklists</h4>
      <div class="statistic-section"></div>
    </div>

    <div class="dashboard-section">
      <h4>Item Status</h4>
      <div class="statistic-section">
        <div class="statistic-card">
          <el-statistic :value="complianceItemStatistics?.activeItems">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Active
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="complianceItemStatistics?.inactiveItems">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Inactive
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="complianceItemStatistics?.unusedItems">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Unused
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="complianceItemStatistics?.archivedItems">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Archived
              </div>
            </template>
          </el-statistic>
        </div>
      </div>
    </div>
    <div class="dashboard-section">
      <h4>Actions Required</h4>
      <div class="statistic-section"></div>
    </div>
    <div class="dashboard-section">
      <h4>Workflow Progress</h4>
      <div class="statistic-section"></div>
    </div>
  </div>
</template>

<style lang="less">
.main-dashboard {
  display: grid;
  margin: 0 auto;
  grid-template-columns: repeat(1, minmax(auto, 1000px));
  grid-template-rows: 1fr;
  grid-gap: 64px;

  .dashboard-section {
    background-color: #f0f2f5;
    height: fit-content;
    padding: 0 0 10px 20px;
    border-radius: 10px;
  }

  .el-statistic {
    .el-statistic__head {
      font-size: 15px;
      font-weight: 400;
    }
  }

  .statistic-section {
    grid-area: "section";
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-gap: 8px;
  }
  .statistic-card {
    padding: 15px;
  }
}
</style>
